// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-toastify/dist/ReactToastify.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/Montserrat-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/Gilroy-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/Gilroy-ExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/Gilroy-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/RedHatDisplay-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary-surface {
  background: #5d2de1;
  box-shadow: 0px 0px 1px rgba(235, 79, 37, 0.24), 0px 2px 4px -1px rgba(27, 10, 82, 0.12), 0px 8px 8px -4px rgba(235, 79, 37, 0.12);
  border-radius: 12px;
}

.primary-bg {
  background: #5d2de1;
  border-radius: 12px;
}

.secondary-surface {
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);
  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06), -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);
}

.faded-surface {
  background: rgba(93, 45, 225, 0.06);
  border-radius: 12px;
}

.header-surface {
  background: #5d2de1;
  box-shadow: 0px 0px 1px rgba(235, 79, 37, 0.24), 0px 2px 4px -1px rgba(27, 10, 82, 0.12), 0px 8px 8px -4px rgba(235, 79, 37, 0.12);
  border-radius: 12px;
}

.card-surface {
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);
  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06), -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);
}

.dropdown-surface {
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);
  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06), -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);
  border-radius: 12px;
}

.faded-1-surface {
  background: rgba(93, 45, 225, 0.06);
  mix-blend-mode: normal;
  border-radius: 12px;
}

.faded-2-surface {
  background: rgba(60, 53, 210, 0.12);
  mix-blend-mode: normal;
  border-radius: 12px;
}

@font-face {
  font-family: "bold-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "bold-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "semi-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "semi-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "med-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: "bold-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
@font-face {
  font-family: "extra-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
@font-face {
  font-family: "semi-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.sectionTitle {
  color: rgba(20, 16, 41, 0.8);
  font-family: "bold-Poppins";
  font-weight: 700;
  font-size: 36px;
  line-height: 36px;
  position: relative;
}

.lightSectionTitle {
  color: #ffffff;
  font-family: "bold-Poppins";
  font-weight: 700;
  font-size: 36px;
  line-height: 36px;
}

.cardTitle {
  color: rgba(20, 16, 41, 0.8);
  font-family: "semi-Montserrat";
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  display: block;
}

.cardSubTitle {
  color: rgba(20, 16, 41, 0.8);
  font-family: "med-Montserrat";
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  display: block;
}

@font-face {
  font-family: "bold-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "bold-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "semi-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "semi-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "med-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: "bold-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
@font-face {
  font-family: "extra-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
@font-face {
  font-family: "semi-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.pageContent {
  width: 1440px;
  max-width: 100%;
  margin: auto;
}

.pageTitle {
  font-size: 48px;
  line-height: 48px;
  font-weight: 700;
  font-family: "bold-Poppins";
  color: rgba(20, 16, 41, 0.8);
  text-transform: capitalize;
}
@media (max-width: 650px) {
  .pageTitle {
    font-size: 36px;
    line-height: 36px;
  }
}

.slick-prev:before,
.slick-next::before {
  display: none;
}

.horizontal-drag {
  max-width: 100%;
  overflow-x: auto;
  position: relative;
  z-index: 3;
}

.horizontal-drag::-webkit-scrollbar {
  display: none;
}

.scroll-class-container {
  transform: translateY(150px);
  opacity: 0;
  max-width: 100%;
}

.transform-bottom-container {
  transform: translateY(-150px);
  opacity: 0;
  max-width: 100%;
}

.transform-left-container {
  transform: translateX(300px);
  opacity: 0;
  max-width: 100%;
}
@media (max-width: 650px) {
  .transform-left-container {
    transform: translateX(100px);
  }
}

.transform-right-container {
  transform: translateX(-300px);
  opacity: 0;
  max-width: 100%;
}
@media (max-width: 650px) {
  .transform-right-container {
    transform: translateX(100px);
  }
}

.transform-top-left-container {
  transform: translateX(150px) translateY(150px);
  opacity: 0;
}
@media (max-width: 650px) {
  .transform-top-left-container {
    transform: translateX(100px) translateY(150px);
  }
}

.scroll-scale-container {
  transform: scale(0);
  opacity: 0;
}

.first-transform {
  transition: all 0.4s ease-out;
}

.second-transform {
  transition: all 0.4s 0.2s ease-out;
}

.third-transform {
  transition: all 0.4s 0.6s ease-out;
}

.horizontalGridContainer {
  overflow: visible;
  overflow-x: auto;
  position: relative;
  max-width: 100%;
  padding-bottom: 10px;
}

.horizontalGridContainer::-webkit-scrollbar {
  display: none;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

@font-face {
  font-family: "Red Hat Display";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background-color: var(--si-lf-bg-colr);
}

::-webkit-scrollbar-thumb {
  width: 8px;
  border-radius: 4px;
  background-color: var(--si-lf-bg-colr);
}

::-webkit-scrollbar-thumb:hover {
  background-color: var(--si-lf-bg-colr);
}

::-webkit-scrollbar-corner {
  background: none; /* Make the corner transparent */
}

:root {
  --bg-color: #111315;
  --sb-bg-color: #1a1d1f;
  --sb-border-color: #1f2022;
  --hover-bg-color: #272b30;
  --set-bg-color: #212528;
  --premium-bg-color: rgba(74, 196, 108, 0.2);
  --free-bg-color: rgba(232, 84, 84, 0.15);
  --light-bg-color: #292d30;
  --dark-bg-btn-color: #464a4d;
  --logout-bg-color: rgba(232, 84, 84, 0.15);
  --support-bg-color: white;
  --font-color: #fff;
  --font-dark-color: #7c7c7d;
  --font-premium-color: #4ac46c;
  --font-light-color: #6f767e;
  --font-dark-btn-color: #fcfcfc;
  --si-bg-color: #0a0c0e;
  --si-lf-bg-colr: #141618;
  --si-more-icon: url(#paint6_linear_1_4083);
  --si-connect-box-border: #2a2b2c;
  --si-ri-heading: linear-gradient(271deg, #b8b8b8 11.01%, #fff 100.33%);
  --si-light-font-color: white;
  --re-svg-icon-bg: #533c29;
  --re-select-dark-bg: #1a1d1f;
  --re-border-color: #222324;
  --re-white-button-bg: linear-gradient(0deg, #fff 0%, #fff 100%),
    linear-gradient(114deg, #45cc8b 2.76%, #2bc6bc 98.03%),
    linear-gradient(90deg, #474eeb 0%, #7177ec 100%), #212121;
  --re-white-yellow-bg: linear-gradient(
      316deg,
      #ffa329 4.43%,
      #fe7b1c 56.59%,
      #fc2a01 150.36%
    ),
    linear-gradient(90deg, #474eeb 0%, #7177ec 100%), #212121;
  --re-black-yellow-bg: #272b30;
  --re-data-left-bg: #272b30;
  --re-rate-bg: #3a3e43;
  --re-progress-bg: #34383d;
  --re-horizontal-bg: #222324;
  --re-special-arrow-bg: white;
  --re-mobile-title-border-bg: #242527;
  --re-mobile-tab-bg: #1a1d1f;
  --re-mobile-tab-hover-bg: #fff;
  --re-from-color: #777778;
  --re-white-button-color: #050507;
  --mem-here-color: #fd84dc;
  --mem-popular-bg: #fff;
  --mem-card-border: #1a1d1f;
  --mem-icon-color: url(#paint3_linear_16_4081);
  --st-free-label-bg: #1a1d1f;
  --st-expired-label-bg: rgba(232, 84, 84, 0.2);
  --st-view-btn-bg: #202325;
  --ld-bg: rgba(0, 0, 0, 0.7);
}

[data-theme=light-theme] {
  --bg-color: #f4f4f4;
  --sb-bg-color: #fcfcfc;
  --sb-border-color: #fcfcfc;
  --hover-bg-color: #e2e2e2;
  --set-bg-color: #e2e2e2;
  --premium-bg-color: rgba(63, 137, 84, 0.2);
  --free-bg-color: rgba(232, 84, 84, 0.15);
  --light-bg-color: linear-gradient(
      316deg,
      #ffa329 4.43%,
      #fe7b1c 56.59%,
      #fc2a01 150.36%
    ),
    linear-gradient(0deg, #464a4d 0%, #464a4d 100%), #c1c1c1;
  --dark-bg-btn-color: linear-gradient(0deg, #c1c1c1 0%, #c1c1c1 100%), #464a4d;
  --logout-bg-color: #e2e2e2;
  --support-bg-color: #e2e2e2;
  --font-color: #1a1d1f;
  --font-dark-color: #6f767e;
  --font-premium-color: #3f8954;
  --font-light-color: white;
  --font-dark-btn-color: #6f767e;
  --si-bg-color: #f4f4f4;
  --si-lf-bg-colr: #fcfcfc;
  --si-more-icon: black;
  --si-connect-box-border: #fcfcfc;
  --si-ri-heading: #1a1d1f;
  --si-light-font-color: #1a1d1f;
  --re-svg-icon-bg: #6f767e;
  --re-select-dark-bg: #e3e3e3;
  --re-border-color: rgba(0, 0, 0, 0.11);
  --re-white-button-bg: linear-gradient(0deg, #e3e3e3 0%, #e3e3e3 100%), #272b30;
  --re-white-yellow-bg: linear-gradient(
      316deg,
      #ffa329 4.43%,
      #fe7b1c 56.59%,
      #fc2a01 150.36%
    ),
    linear-gradient(90deg, #474eeb 0%, #7177ec 100%), #212121;
  --re-black-yellow-bg: linear-gradient(0deg, #e3e3e3 0%, #e3e3e3 100%), #272b30;
  --re-data-left-bg: #e3e3e3;
  --re-rate-bg: #fff;
  --re-progress-bg: #fff;
  --re-horizontal-bg: #d9d9d9;
  --re-special-arrow-bg: black;
  --re-mobile-title-border-bg: #dfdfe0;
  --re-mobile-tab-bg: white;
  --re-mobile-tab-hover-bg: #1a1d1f;
  --re-from-color: #777778;
  --re-white-button-color: #050507;
  --mem-here-color: #fe7b1c;
  --mem-popular-bg: #d6d6d6;
  --mem-card-border: #dfdfe0;
  --mem-icon-color: #6f6f72;
  --st-free-label-bg: rgba(74, 196, 108, 0.2);
  --st-expired-label-bg: rgba(232, 84, 84, 0.6);
  --st-view-btn-bg: linear-gradient(0deg, #fff 0%, #fff 100%),
    linear-gradient(114deg, #45cc8b 2.76%, #2bc6bc 98.03%),
    linear-gradient(90deg, #474eeb 0%, #7177ec 100%), #212121;
  --ld-bg: rgba(255, 255, 255, 0.7);
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.yAxis {
  background-color: var(--bg-color) !important;
  z-index: 2;
  position: relative;
  pointer-events: none;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/shared/_surface.scss","webpack://./src/index.scss","webpack://./src/assets/stylesheets/_variables.scss","webpack://./src/assets/stylesheets/shared/_typography.scss","webpack://./src/assets/stylesheets/shared/_sharedStyles.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kIAAA;EAGA,mBAAA;ACAF;;ADEA;EACE,mBAAA;EACA,mBAAA;ACCF;;ADCA;EACE,6EAAA;EACA,yHAAA;ACEF;;ADCA;EACE,mCAAA;EACA,mBAAA;ACEF;;ADAA;EACE,mBAAA;EACA,kIAAA;EAGA,mBAAA;ACCF;;ADCA;EACE,6EAAA;EACA,yHAAA;ACEF;;ADCA;EACE,6EAAA;EACA,yHAAA;EAEA,mBAAA;ACCF;;ADMA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;ACHF;;ADKA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;ACFF;;ACLA;EACE,2BAAA;EACA,4CAAA;ADQF;ACNA;EACE,8BAAA;EACA,4CAAA;ADQF;ACNA;EACE,2BAAA;EACA,4CAAA;ADQF;ACNA;EACE,8BAAA;EACA,4CAAA;ADQF;ACNA;EACE,0BAAA;EACA,4CAAA;ADQF;ACNA;EACE,6BAAA;EACA,4CAAA;ADQF;ACNA;EACE,0BAAA;EACA,4CAAA;ADQF;ACNA;EACE,2BAAA;EACA,4CAAA;ADQF;ACNA;EACE,0BAAA;EACA,4CAAA;ADQF;ACNA;EACE,yBAAA;EACA,4CAAA;ADQF;AExFA;EACE,4BDCgB;ECAhB,2BDiFuB;EChFvB,gBDoCU;ECnCV,eDoBc;ECnBd,iBD4BgB;EC3BhB,kBAAA;AF0FF;;AExFA;EACE,cDNY;ECOZ,2BDyEuB;ECxEvB,gBD4BU;EC3BV,eDYc;ECXd,iBDoBgB;ADuElB;;AEzFA;EACE,4BDdgB;ECehB,8BDsEsB;ECrEtB,gBDoBS;ECnBT,eAAA;EACA,iBDSe;ECRf,cAAA;AF4FF;;AE1FA;EACE,4BDtBgB;ECuBhB,6BD+DqB;EC9DrB,gBDWW;ECVX,eDVa;ECWb,iBDDe;ECEf,cAAA;AF6FF;;AChFA;EACE,2BAAA;EACA,4CAAA;ADmFF;ACjFA;EACE,8BAAA;EACA,4CAAA;ADmFF;ACjFA;EACE,2BAAA;EACA,4CAAA;ADmFF;ACjFA;EACE,8BAAA;EACA,4CAAA;ADmFF;ACjFA;EACE,0BAAA;EACA,4CAAA;ADmFF;ACjFA;EACE,6BAAA;EACA,4CAAA;ADmFF;ACjFA;EACE,0BAAA;EACA,4CAAA;ADmFF;ACjFA;EACE,2BAAA;EACA,4CAAA;ADmFF;ACjFA;EACE,0BAAA;EACA,4CAAA;ADmFF;ACjFA;EACE,yBAAA;EACA,4CAAA;ADmFF;AGnKA;EACE,aAAA;EACA,eAAA;EACA,YAAA;AHqKF;;AGnKA;EACE,eFmBc;EElBd,iBF4BgB;EE3BhB,gBF+BU;EE9BV,2BF0EuB;EEzEvB,4BFRgB;EEShB,0BAAA;AHsKF;AGrKE;EAPF;IAQI,eFWY;IEVZ,iBFmBc;EDqJhB;AACF;;AGtKA;;EAEE,aAAA;AHyKF;;AGvKA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AH0KF;;AGxKA;EACE,aAAA;AH2KF;;AGzKA;EACE,4BAAA;EACA,UAAA;EACA,eAAA;AH4KF;;AG1KA;EACE,6BAAA;EACA,UAAA;EACA,eAAA;AH6KF;;AG3KA;EACE,4BAAA;EACA,UAAA;EACA,eAAA;AH8KF;AG7KE;EAJF;IAKI,4BAAA;EHgLF;AACF;;AG9KA;EACE,6BAAA;EACA,UAAA;EACA,eAAA;AHiLF;AGhLE;EAJF;IAKI,4BAAA;EHmLF;AACF;;AGjLA;EACE,8CAAA;EACA,UAAA;AHoLF;AGnLE;EAHF;IAII,8CAAA;EHsLF;AACF;;AGpLA;EACE,mBAAA;EACA,UAAA;AHuLF;;AGrLA;EACE,6BAAA;AHwLF;;AGtLA;EACE,kCAAA;AHyLF;;AGvLA;EACE,kCAAA;AH0LF;;AGxLA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AH2LF;;AGzLA;EACE,aAAA;AH4LF;;AA7QA;EACE,UAAA;EACA,SAAA;EACA,sBAAA;AAgRF;;AA7QA;EACE,8BAAA;EACA,+DAAA;AAgRF;AA5QA;EACE,UAAA;EACA,WAAA;AA8QF;;AA3QA;EACE,sCAAA;AA8QF;;AA3QA;EACE,UAAA;EACA,kBAAA;EACA,sCAAA;AA8QF;;AA3QA;EACE,sCAAA;AA8QF;;AA3QA;EACE,gBAAA,EAAA,gCAAA;AA8QF;;AA3QA;EAEE,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;EACA,uBAAA;EACA,2CAAA;EACA,wCAAA;EACA,yBAAA;EACA,4BAAA;EACA,0CAAA;EACA,yBAAA;EAEA,kBAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,gCAAA;EACA,sEAAA;EAEA,4BAAA;EAGA,yBAAA;EACA,4BAAA;EACA,0BAAA;EACA;;6DAAA;EAGA;;;;;;6DAAA;EAOA,6BAAA;EACA,0BAAA;EACA,qBAAA;EACA,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,oCAAA;EACA,2BAAA;EACA,8BAAA;EAEA,wBAAA;EACA,gCAAA;EAGA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,6CAAA;EAGA,2BAAA;EACA,6CAAA;EACA,yBAAA;EAGA,2BAAA;AAgQF;;AA7PA;EAEE,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;EACA,uBAAA;EACA,0CAAA;EACA,wCAAA;EACA;;;;;;4DAAA;EAOA,6EAAA;EACA,0BAAA;EACA,2BAAA;EAEA,qBAAA;EACA,0BAAA;EACA,6BAAA;EACA,yBAAA;EACA,8BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,qBAAA;EACA,gCAAA;EACA,wBAAA;EAEA,8BAAA;EAGA,yBAAA;EACA,4BAAA;EACA,sCAAA;EACA,8EAAA;EACA;;;;;;6DAAA;EAOA,8EAAA;EACA,0BAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,oCAAA;EACA,yBAAA;EACA,iCAAA;EAEA,wBAAA;EACA,gCAAA;EAGA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EAGA,2CAAA;EACA,6CAAA;EACA;;6DAAA;EAKA,iCAAA;AAkPF;;AA/OA;EACE,SAAA;EACA,8JAAA;EAGA,mCAAA;EACA,kCAAA;EACA,kBAAA;AAgPF;;AA7OA;EACE,+EAAA;AAgPF;;AA5OA;EACE,4CAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;AA+OF","sourcesContent":[".primary-surface {\n  background: #5d2de1;\n  box-shadow: 0px 0px 1px rgba(235, 79, 37, 0.24),\n    0px 2px 4px -1px rgba(27, 10, 82, 0.12),\n    0px 8px 8px -4px rgba(235, 79, 37, 0.12);\n  border-radius: 12px;\n}\n.primary-bg {\n  background: #5d2de1;\n  border-radius: 12px;\n}\n.secondary-surface {\n  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);\n  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06),\n    -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);\n}\n.faded-surface {\n  background: rgba(93, 45, 225, 0.06);\n  border-radius: 12px;\n}\n.header-surface {\n  background: #5d2de1;\n  box-shadow: 0px 0px 1px rgba(235, 79, 37, 0.24),\n    0px 2px 4px -1px rgba(27, 10, 82, 0.12),\n    0px 8px 8px -4px rgba(235, 79, 37, 0.12);\n  border-radius: 12px;\n}\n.card-surface {\n  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);\n  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06),\n    -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);\n}\n.dropdown-surface {\n  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);\n  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06),\n    -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);\n  border-radius: 12px;\n}\n// .popup-surface {\n//   background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);\n//   box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06),\n//     -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);\n// }\n.faded-1-surface {\n  background: rgba(93, 45, 225, 0.06);\n  mix-blend-mode: normal;\n  border-radius: 12px;\n}\n.faded-2-surface {\n  background: rgba(60, 53, 210, 0.12);\n  mix-blend-mode: normal;\n  border-radius: 12px;\n}\n","@use '/src/assets/stylesheets/shared/surface';\n@use '/src/assets/stylesheets/shared/typography';\n@import '/src/assets/stylesheets/shared/sharedStyles';\n@import 'react-toastify/dist/ReactToastify.css';\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n@font-face {\n  font-family: 'Red Hat Display';\n  src: url('./assets/fonts/RedHatDisplay-VariableFont_wght.ttf')\n    format('truetype');\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background-color: var(--si-lf-bg-colr);\n}\n\n::-webkit-scrollbar-thumb {\n  width: 8px;\n  border-radius: 4px;\n  background-color: var(--si-lf-bg-colr);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: var(--si-lf-bg-colr);\n}\n\n::-webkit-scrollbar-corner {\n  background: none; /* Make the corner transparent */\n}\n\n:root {\n  // top nav bar and side bar\n  --bg-color: #111315; // bg\n  --sb-bg-color: #1a1d1f; // side bar bg\n  --sb-border-color: #1f2022; // side border color\n  --hover-bg-color: #272b30; // hover bg\n  --set-bg-color: #212528; // setting panel bg\n  --premium-bg-color: rgba(74, 196, 108, 0.2); // premium button bg\n  --free-bg-color: rgba(232, 84, 84, 0.15);\n  --light-bg-color: #292d30; // light button bg\n  --dark-bg-btn-color: #464a4d; // dark button bg\n  --logout-bg-color: rgba(232, 84, 84, 0.15); // logout button bg\n  --support-bg-color: white; // support button bg\n\n  --font-color: #fff; // font\n  --font-dark-color: #7c7c7d; // dark font\n  --font-premium-color: #4ac46c; // premium button font\n  --font-light-color: #6f767e; // light button font\n  --font-dark-btn-color: #fcfcfc; // dark button font\n\n  // sign in\n  --si-bg-color: #0a0c0e; // bg\n  --si-lf-bg-colr: #141618; // left bg\n  --si-more-icon: url(#paint6_linear_1_4083); //moreAbout icon color\n  --si-connect-box-border: #2a2b2c; //connect box border\n  --si-ri-heading: linear-gradient(271deg, #b8b8b8 11.01%, #fff 100.33%);\n\n  --si-light-font-color: white; // light font\n\n  // residential\n  --re-svg-icon-bg: #533c29; // purchase icon bg\n  --re-select-dark-bg: #1a1d1f; // dark select bg\n  --re-border-color: #222324; // lemonlab border color\n  --re-white-button-bg: linear-gradient(0deg, #fff 0%, #fff 100%),\n    linear-gradient(114deg, #45cc8b 2.76%, #2bc6bc 98.03%),\n    linear-gradient(90deg, #474eeb 0%, #7177ec 100%), #212121;\n  --re-white-yellow-bg: linear-gradient(\n      316deg,\n      #ffa329 4.43%,\n      #fe7b1c 56.59%,\n      #fc2a01 150.36%\n    ),\n    linear-gradient(90deg, #474eeb 0%, #7177ec 100%), #212121;\n  --re-black-yellow-bg: #272b30; // black button bg\n  --re-data-left-bg: #272b30; // data-left bg\n  --re-rate-bg: #3a3e43; // rate bg\n  --re-progress-bg: #34383d; // progress bar bg\n  --re-horizontal-bg: #222324; // horizontal bar bg\n  --re-special-arrow-bg: white; // special arrow bg\n  --re-mobile-title-border-bg: #242527; // mobile title horizontal bg\n  --re-mobile-tab-bg: #1a1d1f; // mobile tab bg\n  --re-mobile-tab-hover-bg: #fff;\n\n  --re-from-color: #777778; // from label color\n  --re-white-button-color: #050507; // white button color\n\n  //membership\n  --mem-here-color: #fd84dc;\n  --mem-popular-bg: #fff;\n  --mem-card-border: #1a1d1f;\n  --mem-icon-color: url(#paint3_linear_16_4081);\n\n  //static proxies\n  --st-free-label-bg: #1a1d1f;\n  --st-expired-label-bg: rgba(232, 84, 84, 0.2);\n  --st-view-btn-bg: #202325;\n\n  //loading\n  --ld-bg: rgba(0, 0, 0, 0.7);\n}\n\n[data-theme='light-theme'] {\n  // top nav bar and side bar\n  --bg-color: #f4f4f4;\n  --sb-bg-color: #fcfcfc;\n  --sb-border-color: #fcfcfc;\n  --hover-bg-color: #e2e2e2;\n  --set-bg-color: #e2e2e2;\n  --premium-bg-color: rgba(63, 137, 84, 0.2);\n  --free-bg-color: rgba(232, 84, 84, 0.15);\n  --light-bg-color: linear-gradient(\n      316deg,\n      #ffa329 4.43%,\n      #fe7b1c 56.59%,\n      #fc2a01 150.36%\n    ),\n    linear-gradient(0deg, #464a4d 0%, #464a4d 100%), #c1c1c1;\n  --dark-bg-btn-color: linear-gradient(0deg, #c1c1c1 0%, #c1c1c1 100%), #464a4d;\n  --logout-bg-color: #e2e2e2;\n  --support-bg-color: #e2e2e2;\n\n  --font-color: #1a1d1f;\n  --font-dark-color: #6f767e;\n  --font-premium-color: #3f8954;\n  --font-light-color: white;\n  --font-dark-btn-color: #6f767e;\n\n  // sign in\n  --si-bg-color: #f4f4f4;\n  --si-lf-bg-colr: #fcfcfc;\n  --si-more-icon: black;\n  --si-connect-box-border: #fcfcfc;\n  --si-ri-heading: #1a1d1f;\n\n  --si-light-font-color: #1a1d1f;\n\n  // residential\n  --re-svg-icon-bg: #6f767e;\n  --re-select-dark-bg: #e3e3e3;\n  --re-border-color: rgba(0, 0, 0, 0.11);\n  --re-white-button-bg: linear-gradient(0deg, #e3e3e3 0%, #e3e3e3 100%), #272b30;\n  --re-white-yellow-bg: linear-gradient(\n      316deg,\n      #ffa329 4.43%,\n      #fe7b1c 56.59%,\n      #fc2a01 150.36%\n    ),\n    linear-gradient(90deg, #474eeb 0%, #7177ec 100%), #212121;\n  --re-black-yellow-bg: linear-gradient(0deg, #e3e3e3 0%, #e3e3e3 100%), #272b30;\n  --re-data-left-bg: #e3e3e3;\n  --re-rate-bg: #fff;\n  --re-progress-bg: #fff;\n  --re-horizontal-bg: #d9d9d9;\n  --re-special-arrow-bg: black;\n  --re-mobile-title-border-bg: #dfdfe0;\n  --re-mobile-tab-bg: white;\n  --re-mobile-tab-hover-bg: #1a1d1f;\n\n  --re-from-color: #777778;\n  --re-white-button-color: #050507;\n\n  //membership\n  --mem-here-color: #fe7b1c;\n  --mem-popular-bg: #d6d6d6;\n  --mem-card-border: #dfdfe0;\n  --mem-icon-color: #6f6f72;\n\n  //static proxies\n  --st-free-label-bg: rgba(74, 196, 108, 0.2);\n  --st-expired-label-bg: rgba(232, 84, 84, 0.6);\n  --st-view-btn-bg: linear-gradient(0deg, #fff 0%, #fff 100%),\n    linear-gradient(114deg, #45cc8b 2.76%, #2bc6bc 98.03%),\n    linear-gradient(90deg, #474eeb 0%, #7177ec 100%), #212121;\n\n  //loading\n  --ld-bg: rgba(255, 255, 255, 0.7);\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.yAxis {\n  background-color: var(--bg-color) !important;\n  z-index: 2;\n  position: relative;\n  pointer-events: none;\n  color: white;\n}\n","// colors\n$primary-color: #5d2de1;\n$dark-color: #141029;\n$cultured-color: #f5f7fa;\n$dark-text-color: rgba(20, 16, 41, 0.8);\n$white-color: #ffffff;\n$card-gradient-color: linear-gradient(\n  135deg,\n  #ffffff 0%,\n  #fafbfc 51.82%,\n  #f5f7fa 100%\n);\n$pink-color: #e0e0ff;\n$white-color-40: rgba(255, 255, 255, 0.4);\n$white-color-4: rgba(224, 224, 255, 0.04);\n$danger-color: #f54562;\n\n// fonts\n\n$font-size-xs: 13px;\n$font-size-sm: 14px;\n$font-size-md: 16px;\n$font-size-xm: 18px;\n$font-size-lg: 20px;\n$font-size-xl: 24px;\n$font-size-xxl: 30px;\n$font-size-3xl: 36px;\n$font-size-4xl: 48px;\n\n$font-height-xs: 16px;\n$font-height-sm: 20px;\n$font-height-md: 24px;\n$font-height-xm: 28px;\n$font-height-lg: 30px;\n$font-height-xl: 32px;\n$font-height-xxl: 36px;\n$font-height-3xl: 40px;\n$font-height-4xl: 48px;\n\n$font-light: 500;\n$font-med: 600;\n$font-bold: 700;\n$font-extra: 800;\n\n@font-face {\n  font-family: \"bold-Poppins\";\n  src: url(/assets/fonts/Poppins-Bold.ttf);\n}\n@font-face {\n  font-family: \"bold-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Bold.ttf);\n}\n@font-face {\n  font-family: \"semi-Poppins\";\n  src: url(/assets/fonts/Poppins-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"semi-Montserrat\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-Poppins\";\n  src: url(/assets/fonts/Poppins-Medium.ttf);\n}\n@font-face {\n  font-family: \"med-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Medium.ttf);\n}\n@font-face {\n  font-family: \"bold-gilory\";\n  src: url(/assets/fonts/Gilroy-Bold.ttf);\n}\n@font-face {\n  font-family: \"extra-gilory\";\n  src: url(/assets/fonts/Gilroy-ExtraBold.otf);\n}\n@font-face {\n  font-family: \"semi-gilory\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-gilory\";\n  src: url(/assets/fonts/Gilroy-Medium.ttf);\n}\n\n$title-font-family-bold: \"bold-Poppins\";\n$title-font-family-semi: \"semi-Poppins\";\n$title-font-family-med: \"med-Poppins\";\n$text-font-family-bold: \"bold-Montserrat\";\n$text-font-family-semi: \"semi-Montserrat\";\n$text-font-family-med: \"med-Montserrat\";\n$number-font-family-bold: \"bold-gilory\";\n$number-font-family-extra: \"extra-gilory\";\n$number-font-family-semi: \"semi-gilory\";\n$number-font-family-med: \"med-gilory\";\n\n// dark and light theme\n$dark-bg-color: #111315; // background\n$dark-sb-bg-color: #242527; // sidebar\n\n$light-bg-color: #F4F4F4; // background\n$light-sb-bg-color: #FCFCFC; // sidebar","@import \"../variables\";\n\n.sectionTitle {\n  color: $dark-text-color;\n  font-family: $title-font-family-bold;\n  font-weight: $font-bold;\n  font-size: $font-size-3xl;\n  line-height: $font-height-xxl;\n  position: relative;\n}\n.lightSectionTitle {\n  color: $white-color;\n  font-family: $title-font-family-bold;\n  font-weight: $font-bold;\n  font-size: $font-size-3xl;\n  line-height: $font-height-xxl;\n}\n.cardTitle {\n  color: $dark-text-color;\n  font-family: $text-font-family-semi;\n  font-weight: $font-med;\n  font-size: $font-size-md;\n  line-height: $font-height-md;\n  display: block;\n}\n.cardSubTitle {\n  color: $dark-text-color;\n  font-family: $text-font-family-med;\n  font-weight: $font-light;\n  font-size: $font-size-xs;\n  line-height: $font-height-xs;\n  display: block;\n}\n","@import \"/src/assets/stylesheets/variables\";\n\n.pageContent {\n  width: 1440px;\n  max-width: 100%;\n  margin: auto;\n}\n.pageTitle {\n  font-size: $font-size-4xl;\n  line-height: $font-height-4xl;\n  font-weight: $font-bold;\n  font-family: $title-font-family-bold;\n  color: $dark-text-color;\n  text-transform: capitalize;\n  @media (max-width: 650px) {\n    font-size: $font-size-3xl;\n    line-height: $font-height-xxl;\n  }\n}\n.slick-prev:before,\n.slick-next::before {\n  display: none;\n}\n.horizontal-drag {\n  max-width: 100%;\n  overflow-x: auto;\n  position: relative;\n  z-index: 3;\n}\n.horizontal-drag::-webkit-scrollbar {\n  display: none;\n}\n.scroll-class-container {\n  transform: translateY(150px);\n  opacity: 0;\n  max-width: 100%;\n}\n.transform-bottom-container {\n  transform: translateY(-150px);\n  opacity: 0;\n  max-width: 100%;\n}\n.transform-left-container {\n  transform: translateX(300px);\n  opacity: 0;\n  max-width: 100%;\n  @media (max-width: 650px) {\n    transform: translateX(100px);\n  }\n}\n.transform-right-container {\n  transform: translateX(-300px);\n  opacity: 0;\n  max-width: 100%;\n  @media (max-width: 650px) {\n    transform: translateX(100px);\n  }\n}\n.transform-top-left-container {\n  transform: translateX(150px) translateY(150px);\n  opacity: 0;\n  @media (max-width: 650px) {\n    transform: translateX(100px) translateY(150px);\n  }\n}\n.scroll-scale-container {\n  transform: scale(0);\n  opacity: 0;\n}\n.first-transform {\n  transition: all 0.4s ease-out;\n}\n.second-transform {\n  transition: all 0.4s 0.2s ease-out;\n}\n.third-transform {\n  transition: all 0.4s 0.6s ease-out;\n}\n.horizontalGridContainer {\n  overflow: visible;\n  overflow-x: auto;\n  position: relative;\n  max-width: 100%;\n  padding-bottom: 10px;\n}\n.horizontalGridContainer::-webkit-scrollbar {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
